import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const ContactSection = () => (
    <ScrollableAnchor id="contact">
        <section className="content-section bg-secondary text-white text-center animatedParent animateOnce" data-appear-top-offset='-300' data-sequence='500'>
            <div className="container">
                <div className="content-section-heading">
                    <h3 className="text-secondary mb-0">Kontakt</h3>
                    <h2 className="mb-5">Wie ihr uns erreicht</h2>
                </div>
                <div>
                    <div className="animated bounceIn" data-id="1">
                        <h3><i className="icon-envelope"/> E-Mail</h3>
                        <h4><a className="text-dark" href="mailto:info@medizentrum.life">info@medizentrum.life</a></h4>
                    </div>
                    <br/>
                    <br/>
                    <div className="animated bounceIn" data-id="2">
                        <h3><i className="icon-phone"/> Telefon</h3>
                        <h4><a className="text-dark" href="callto://+079149385838">0791/49385838</a></h4>
                    </div>
                </div>
            </div>
        </section>
    </ScrollableAnchor>
);
export default ContactSection;



// WEBPACK FOOTER //
// ./src/main/contact.js